import { render, staticRenderFns } from "./BCXPanel.vue?vue&type=template&id=9879a6d0&scoped=true"
import script from "./BCXPanel.vue?vue&type=script&lang=ts"
export * from "./BCXPanel.vue?vue&type=script&lang=ts"
import style0 from "./BCXPanel.vue?vue&type=style&index=0&id=9879a6d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9879a6d0",
  null
  
)

export default component.exports